import PresortDemo from "../components/table/DataTable";
import { useEffect, useRef, useState } from "react";
import "./page.css"
import { useCreateOrUpdateOrderMutation, useGetOrdersQuery } from "../store/api/orderAPI";
import { orderProcColumn } from "../metadata/order";
import { SpeedDial } from "primereact/speeddial";
import { useActionsHook } from "../hooks/useActionsHook";
import { Toast } from 'primereact/toast';
import { useNavigate, useParams } from "react-router-dom";
import { useTranslatedColumns } from "../hooks/useTranslatedColumns";

import ShippingLabel from "../components/common/PrintOrderLabel";
import { t } from "i18next";
import TrackModal from "./TrackModal";
import Editor from "../components/UI/editor";
import MyButton from "../components/UI/Button";



function OrderProcess() {
	const { id } = useParams();
	const [formData, setFormData] = useState({});
	const scanEditor = useRef({});
	const navigate = useNavigate();
	const { data, error, isLoading } = useGetOrdersQuery({
		status: id,
		guid: formData?.tcode
	});
	const [trackModal, setTrackModal] = useState({ visible: false, trackingNumber: null });
	const toast = useRef(null);
	const orderColumnTr = useTranslatedColumns(orderProcColumn);

	const printRef = useRef();
	const [printData, setPrintData] = useState(null);
	const onBlur = (e, attr, value) => {
		setFormData(state => {
			return {
				...state,
				[attr]: value
			}
		});
	}
	useEffect(() => {
		scanEditor.current?.focus();
	}, []);

	const actions = useActionsHook([
		{
			onClick: (e, data) => {
				navigate("/setUser/" + data?.tracking_number, {
					state: {
						formData: data
					}
				})
			},
			icon: "pi pi-plus"
		}
	])
	const items = [
		{
			label: 'React Website',
			icon: 'pi pi-external-link',
			command: () => {
				// window.location.href = 'https://react.dev/';
			}
		}
	];


	return (
		<>
			<div
				style={{
					display: "flex",
					alignItems: "center",
					gap: 12,
					width: "100%",
					padding: "4px 8px"
				}}
			>
				<Editor onBlur={onBlur} data={formData} attr="tcode" placeholder="Поиск по треку..." trim refEl={scanEditor}
					onKeyDown={(e) => {
						if (e.key === "Enter" && formData.tcode && formData.tcode?.length && formData.tcode.length > 7) {
							if (data && data?.length && [...data].length > 0) {
								navigate("/setUser", {
									state: {
										formData: data[0],
									}
								})
								return
							}
							navigate("/setUser", {
								state: {
									formData: formData,
								}
							})
						}
					}} />
				{
					(!!formData.tcode && !data?.length) &&
					<MyButton
						label={t('addStack')}
						outlined
						onClick={() => {
							navigate("/setUser", {
								state: {
									formData: formData
								}
							})
							//							setFormData(state => ({ ...state, tcode: "" }))

						}}
					/>
				}
			</div>
			<Toast ref={toast} />
			<PresortDemo
				isLoading={isLoading}
				data={data}
				column={orderColumnTr.filter(i => !i.hidden) ?? Object.keys(data.data[0])}
				toggleSidebar={() => { }}
				deleteHandler={(row, field) => {
					console.log(row, field);
				}}
				actions={actions}
			/>
			{id == 0 && <SpeedDial
				model={items}
				radius={120}
				type="quarter-circle"
				onClick={() => {
				}}
				direction="up-left"
				style={{ right: 15, bottom: 15 }} />}

			<div ref={printRef} style={{ position: "absolute", left: "-9999px" }}>
				{printData && <ShippingLabel {...printData} />}
			</div>

			<TrackModal
				visible={trackModal.visible}
				trackingNumber={trackModal.trackingNumber}
				onHide={() => setTrackModal({ visible: false, trackingNumber: null })}
			/>
		</>);
}

export default OrderProcess;